import { put, takeLatest } from 'redux-saga/effects';
import { Task, TaskAPI } from 'api/tasks';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  FetchTaskActionPayload,
  fetchTaskSaga,
  saveTaskDetailSaga,
} from '../actions';
import { fetchTaskDetailStart, fetchTaskDetailError } from '../slice';

function* getTaskByIdSaga(
  action: StoreActionProps<FetchTaskActionPayload>,
): Generator {
  const { projectId, taskId, fetchInBackground, onSuccess } = action.payload;

  try {
    if (!fetchInBackground) {
      yield put(fetchTaskDetailStart(taskId));
    }

    const task = (yield TaskAPI.getTask(projectId, taskId)) as Task;

    /* when get DELETED task, backend will return 204: no content. So adding condition for safety */
    if (task) {
      if (onSuccess) {
        onSuccess(task as any);
      }
      yield put(saveTaskDetailSaga(task));
    }
  } catch (error) {
    logger.error('getTaskByIdSaga failed', { error });
    yield put(fetchTaskDetailError(taskId));
  }
}

export const watchGetTaskByIdSaga = function* (): Generator {
  yield takeLatest(fetchTaskSaga.type, getTaskByIdSaga);
};
